//react
import { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";

//css
import styled from "styled-components";

// img
import CloseSvg from "../../assets/img/icon/icon_close.svg";

// responsive
import { M, T, MMinus } from "../../utils/MT";

// component
import LikeButton from "../button/LikeButton";

export default function ProductBox(props) {
    //페이지 이동
    const navigate = useNavigate();
    const goDetailPage = () => {
        navigate(`/product/detail/` + props.id);
    };

    // 할인일때
    const [isDiscount, setIsDiscount] = useState(true);

    return (
        <ListBox key={"itemList" + props.id}>
            {
                // wish 페이지 삭제버튼
                props.isWish ? (
                    <DelBtnWrap
                        onClick={() => {
                            console.log("삭제되어랏!");
                        }}
                    >
                        <CloseIcon src={CloseSvg} alt="삭제" />
                    </DelBtnWrap>
                ) : null
            }
            <ImgWrap
                onClick={() => {
                    goDetailPage();
                }}
            >
                <Img src={props.productImg} alt="제품명" />
            </ImgWrap>
            <TextWrap>
                <TopWrap>
                    <Name
                        onClick={() => {
                            goDetailPage();
                        }}
                    >
                        {props.itemName}
                    </Name>
                    <LikeButton id={props.id} />
                </TopWrap>
                <Desc>{props.desc}</Desc>
                <PriceBox>
                    {/* 할인 있을때랑 없을때 */}
                    {isDiscount ? (
                        <>
                            <OriginPriceWrap>
                                <OriginPrice>{props.orginPrice}</OriginPrice>
                                <span>원</span>
                            </OriginPriceWrap>
                            <PriceWrap>
                                <Percent>{props.percent}%</Percent>
                                <Price active={setIsDiscount ? true : null}>{props.price}</Price>
                                <span>원</span>
                            </PriceWrap>
                        </>
                    ) : (
                        <PriceWrap>
                            <Price>{props.price}</Price>
                            <span>원</span>
                        </PriceWrap>
                    )}
                </PriceBox>
            </TextWrap>
        </ListBox>
    );
}

const ListBox = styled.li`
    position: relative;
    width: calc(100vw * (290 / 1920));

    &:not(:nth-child(3n-2)) {
        margin-left: calc(100vw * (95 / 1920));
    }

    &:nth-child(n + 4) {
        margin-top: calc(100vw * (95 / 1920));
    }

    &:hover > p {
        display: flex;
    }

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (290 / 1300));

        &:not(:nth-child(3n-2)) {
            margin-left: calc(100vw * (95 / 1300));
        }

        &:nth-child(n + 4) {
            margin-top: calc(100vw * (95 / 1300));
        }
    }

    @media screen and (max-width: 900px) {
        width: ${M(180)};

        &:not(:nth-child(3n-2)) {
            margin-left: 0;
        }

        &:nth-child(n + 4) {
            margin-top: 0;
        }

        &:nth-child(2n) {
            margin-left: ${M(18)};
        }
        &:nth-child(n + 3) {
            margin-top: ${M(30)};
        }
    }
`;

const DelBtnWrap = styled.p`
    display: none;
    position: absolute;
    top: 0;
    right: 0;

    width: calc(100vw * (50 / 1920));
    height: calc(100vw * (50 / 1920));

    background: rgba(0, 0, 0, 0.5);

    z-index: 2;

    cursor: pointer;

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (50 / 1300));
        height: calc(100vw * (50 / 1300));
    }

    @media screen and (max-width: 900px) {
        display: flex;
        width: ${M(24)};
        height: ${M(24)};
    }
`;

const CloseIcon = styled.img`
    width: calc(100vw * (19 / 1920));
    height: calc(100vw * (19 / 1920));

    margin: auto;

    filter: invert(96%) sepia(89%) saturate(2%) hue-rotate(299deg) brightness(110%) contrast(100%);

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (19 / 1300));
        height: calc(100vw * (19 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: ${M(12)};
        height: ${M(12)};
    }
`;

const ImgWrap = styled.div`
    width: 100%;
    height: calc(100vw * (290 / 1920));

    margin-bottom: calc(100vw * (9 / 1920));

    cursor: pointer;

    @media screen and (max-width: 1300px) {
        height: calc(100vw * (290 / 1300));

        margin-bottom: calc(100vw * (9 / 1300));
    }

    @media screen and (max-width: 900px) {
        height: ${M(180)};
        margin-bottom: ${M(10)};
    }
`;

const Img = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
`;

const TextWrap = styled.div``;

const TopWrap = styled.div`
    display: flex;
    align-items: center;

    padding-right: calc(100vw * (1 / 1920));

    @media screen and (max-width: 1300px) {
        padding-right: calc(100vw * (1 / 1300));
    }

    @media screen and (max-width: 900px) {
        padding-right: 0;
    }
`;

const Name = styled.h3`
    font-family: "Pop-B";
    font-size: calc(100vw * (20 / 1920));

    margin-bottom: calc(100vw * (6 / 1920));

    /* 한줄처리 */
    max-width: calc(100% - calc(100vw * (20 / 1920)));
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    margin-right: auto;
    cursor: pointer;

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (20 / 1300));

        margin-bottom: calc(100vw * (6 / 1300));

        /* 한줄처리 */
        max-width: calc(100% - calc(100vw * (20 / 1300)));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(13)};

        margin-bottom: 0;

        /* 한줄처리 */
        max-width: ${MMinus(20)};
    }
`;

const Desc = styled.p`
    font-size: calc(100vw * (14 / 1920));

    margin-bottom: calc(100vw * (20 / 1920));

    /* 한줄처리 */
    text-overflow: ellipsis;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    word-wrap: break-word;

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (14 / 1300));

        margin-bottom: calc(100vw * (20 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(10)};
        /* letter-spacing: -10px; */
        letter-spacing: ${M(-0.8)};

        margin-bottom: ${M(1)};
    }
`;

const PriceBox = styled.div`
    margin-bottom: calc(100vw * (4 / 1920));

    @media screen and (max-width: 1300px) {
        margin-bottom: calc(100vw * (4 / 1300));
    }

    @media screen and (max-width: 900px) {
        margin-bottom: ${M(2)};
    }
`;

const OriginPriceWrap = styled.div`
    display: flex;
    align-items: baseline;

    & span {
        font-size: calc(100vw * (12 / 1920));
        margin-left: calc(100vw * (11 / 1920));
        color: #aaa;
    }

    @media screen and (max-width: 1300px) {
        & span {
            font-size: calc(100vw * (12 / 1300));
            margin-left: calc(100vw * (11 / 1300));
        }
    }

    @media screen and (max-width: 900px) {
        & span {
            font-size: ${M(14)};
            margin-left: ${M(2)};
        }
    }
`;
const OriginPrice = styled.s`
    font-family: "Pop-M";
    font-size: calc(100vw * (14 / 1920));

    color: #aaa;
    word-break: break-all;

    /* 한줄처리 */
    max-width: calc(100% - calc(100vw * (20 / 1920)));
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (14 / 1300));

        /* 한줄처리 */
        max-width: calc(100% - calc(100vw * (20 / 1300)));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(14)};

        margin-bottom: 0;

        /* 한줄처리 */
        max-width: ${MMinus(20)};
    }
`;

const PriceWrap = styled.div`
    display: flex;
    align-items: baseline;

    & span {
        font-size: calc(100vw * (15 / 1920));
        margin-left: calc(100vw * (6 / 1920));
    }

    @media screen and (max-width: 1300px) {
        & span {
            font-size: calc(100vw * (15 / 1300));
            margin-left: calc(100vw * (6 / 1300));
        }
    }

    @media screen and (max-width: 900px) {
        & span {
            font-size: ${M(12)};

            margin-left: ${M(2)};
        }
    }
`;

const Percent = styled.p`
    font-family: "Pop-B";
    font-size: calc(100vw * (20 / 1920));
    color: var(--main-color);

    margin-right: calc(100vw * (3 / 1920));

    /* 한줄처리 */
    max-width: 20%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (20 / 1300));

        margin-right: calc(100vw * (3 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(14)};
        margin-right: ${M(3)};
    }
`;

const Price = styled.p`
    font-family: "Noto-B";
    font-size: calc(100vw * (19 / 1920));

    /* 한줄처리 */
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (19 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(14)};
    }
`;
